import { jwtDecode } from 'jwt-decode';
import path from "ramda/es/path";
import identity from "ramda/es/identity";
import prop from "ramda/es/prop";
import propOr from "ramda/es/propOr";
import tryCatch from "ramda/es/tryCatch";
import alwaysEmptyObject from "ramda-extension/es/alwaysEmptyObject";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../../constants/appContext';
/**
 * Get appContext from state
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getAppContext(state)
 *
 */ export const getAppContext = createSelector(identity, propOr({}, REDUCER_NAME));
const getFromAppContext = (propName)=>createSelector(getAppContext, prop(propName));
/**
 * Get accessToken from appContext
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getAccessToken(state)
 *
 */ export const getAccessToken = getFromAppContext('accessToken');
export const getDecodedAccessToken = createSelector(getAccessToken, jwtDecode);
export const getUserLogon = createSelector(getDecodedAccessToken, path([
    'token_details',
    'originalUserLogin'
]));
export const getSafelyDecodedAccessToken = createSelector(getAccessToken, tryCatch(jwtDecode, alwaysEmptyObject));
export const getSafeUserLogon = createSelector(getSafelyDecodedAccessToken, path([
    'token_details',
    'originalUserLogin'
]));
/**
 * Get refreshToken from appContext
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getRefreshToken(state)
 *
 */ export const getRefreshToken = getFromAppContext('refreshToken');
/**
 * Get systemId from appContext
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getSystemId(state)
 *
 */ export const getSystemId = getFromAppContext('systemId');
/**
 * Get companyId from appContext
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getCompanyId(state)
 *
 */ export const getCompanyId = getFromAppContext('companyId');
/**
 * Get isAccessTokenPending from appContext
 *
 * @documented
 * @category Selector
 * @example
 *
 *    isPending(state)
 *
 */ export const isPending = getFromAppContext('isAccessTokenPending');
/**
 * Get object containing information needed to request authorization from agw
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getLoginUrlParams(state)
 *
 */ export const getLoginUrlParams = createSelector(getAppContext, path([
    'urls',
    'authorize'
]), ({ clientId, scope, redirectUri }, authorizeUrl)=>({
        authorizeUrl,
        clientId,
        scope,
        redirectUri
    }));
